export default {
    SET_TEMPLATES(state, templates) {
        state.templates = templates
    }
}
